export const MetodosPago = {
  DOMICILIACION_BANCARIA: 1,
  EFECTIVO: 2,
  TARJETA_APP: 3,
  BIZUM_APP: 4,
};
